import { render, staticRenderFns } from "./BuryingPoint.vue?vue&type=template&id=acf4372c&scoped=true"
import script from "./BuryingPoint.vue?vue&type=script&lang=js"
export * from "./BuryingPoint.vue?vue&type=script&lang=js"
import style0 from "./BuryingPoint.vue?vue&type=style&index=0&id=acf4372c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4372c",
  null
  
)

export default component.exports